import { render, staticRenderFns } from "./pageConfigPop.vue?vue&type=template&id=11d7dff2&scoped=true"
import script from "./pageConfigPop.vue?vue&type=script&lang=js"
export * from "./pageConfigPop.vue?vue&type=script&lang=js"
import style0 from "./pageConfigPop.vue?vue&type=style&index=0&id=11d7dff2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d7dff2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11d7dff2')) {
      api.createRecord('11d7dff2', component.options)
    } else {
      api.reload('11d7dff2', component.options)
    }
    module.hot.accept("./pageConfigPop.vue?vue&type=template&id=11d7dff2&scoped=true", function () {
      api.rerender('11d7dff2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/customPage/components/pageConfigPop.vue"
export default component.exports